"use strict";
/**
 * Created by Dale on 05/07/2018.
 */
(function ($, browser) {
    // This will add a method to the Window object (aliased here as 'browser')
    browser.watchXAxisBreakpoint = function (breakpoint, onEnter, onExit, runOnFirstLoadFlag) {
        var firstLoadFlag = typeof runOnFirstLoadFlag !== 'undefined' ?
            runOnFirstLoadFlag :
            false;
        var state = {
            breakpoint: breakpoint,
            position: null,
            callbacks: {
                enter: onEnter,
                exit: onExit,
            },
        };
        var onResize = function () {
            // If the window width is greater than the breakpoint
            if (browser.innerWidth > this.breakpoint &&
                this.position !== 'outside') {
                // Set the position to 'outside'
                this.position = 'outside';
                // if the 'exit' functions exists, trigger it
                if (typeof this.callbacks.exit === 'function') {
                    this.callbacks.exit();
                }
            }
            // If the window width is greater than the breakpoint
            else if (browser.innerWidth <= this.breakpoint &&
                this.position !== 'inside') {
                // Set the position to 'outside'
                this.position = 'inside';
                // if the 'enter' functions exists, trigger it
                if (typeof this.callbacks.enter === 'function') {
                    this.callbacks.enter();
                }
            }
        };
        // Binding 'this' to the state object
        onResize = onResize.bind(state);
        // Running the method on .resize()
        $(browser).resize(onResize);
        // Running the method on first load if the flag is on
        if (firstLoadFlag === true) {
            onResize();
        }
    };
}(jQuery, window));
